import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PollSingleAbstract } from '../../../../../abstracts/poll-single.abstract';
import { IPollAnswers } from '../../../../../models/poll.model';
import { ToastController } from 'ionic-angular';
import { colorPipe } from '../../../../../pipes/color.pipe';
import { has } from 'lodash';
import { UtilitiesProvider } from '../../../../../providers/utilities';

@Component({
  selector: 'app-voting-single-question',
  templateUrl: 'single-question.html'
})

export class VotingSingleQuestionComponent extends PollSingleAbstract implements OnInit, OnChanges {

  public form: FormGroup;

  @Input('config')
  public config: any;

  @Input('answers')
  public answers: IPollAnswers[];

  @Input('block')
  public block: boolean;

  @Input('questionId')
  public questionId: string;

  @Input('userAnswer')
  public userAnswer: any;

  @Input('language')
  public language: string;

  @Input('lastQuestion')
  public lastQuestion: boolean;

  @Input('userHasRecord')
  public userHasRecord: boolean = false;

  constructor(
    public toastCtrl: ToastController,
    private color: colorPipe,
    private utilities: UtilitiesProvider

  ) {
    super(toastCtrl);
  }

  ngOnInit() {
    this.buildForm(false);
    this.patchForm({ id: this.questionId, value: this.userAnswer || '' });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (has(changes, 'block') && changes.block.firstChange === false) {
      if (changes.block.currentValue === true) {
        this.block = false;
        this.utilities.consoleDecorator('emiting to parent component', this.form.value);
        setTimeout(() => {
          this.sendAnswer.emit(this.form.value);
        }, 30);
      }
    }

    if (has(changes, 'questionId') && changes.questionId.firstChange === false) {
      this.patchForm({ id: this.questionId, value: this.userAnswer || '' });

    }

  }

  public checkAnswers() {
    if (this.userAnswer) {
      this.patchForm({ id: this.questionId, value: this.userAnswer });
    }
  }

  public itsElementSelected(idElement: string) {
    return this.form.get('value').value === idElement;
  }

  public getSecondColor(): string {
    return this.color.transform(this.config.style_second_color);
  }

}



// WEBPACK FOOTER //
// ./src/pages/voting/components/voting-question/single-question/single-question.ts